import { Trans, useTranslation } from 'react-i18next';
import { Heading, Text, Center } from '@chakra-ui/react';
import RoundedCard from 'ui/molecules/RoundedCard';
import Button from 'ui/molecules/Button';
import { clearLocalStorage } from 'store/store';
import { useEffect, useState } from 'react';

export const OldCOnfigurationWarning = () => {
  const { t } = useTranslation();
  const [isOldRosselConfigUrl, setIsOldRosselConfigUrl] = useState(false);
  const handleClick = () => {
    clearLocalStorage();
    // GO to prod website!
    window.location.replace('https://reno.energy/simulateur');
  };

  useEffect(() => {
    if (window.location.href.includes('/simulateur-lesoir')) {
      setIsOldRosselConfigUrl(true);
    }
  }, []);

  return (
    <Center w={{ base: 'full', md: '600px' }} textAlign="center">
      <RoundedCard p="25px 10px">
        <Center flexDirection="column" gap="10px">
          <Heading fontSize="3xl" color="primaryColor">
            {t('summary.popup.oldOffer.title')}
          </Heading>
          <Text align="center" px="20px">
            <Trans
              i18nKey={`summary.popup.oldOffer.description${
                isOldRosselConfigUrl ? '.rossel' : ''
              }`}
            >
              text
              <a
                style={{ color: 'green', textDecoration: 'underline' }}
                href="https://content.lesoir.be/marketing/le_soir_habitat/"
              >
                link
              </a>
              text
            </Trans>
          </Text>
          <Button onClick={handleClick} mt="20px">
            {t('summary.popup.oldOffer.cta')}
          </Button>
        </Center>
      </RoundedCard>
    </Center>
  );
};
